export default "__VITE_ASSET__DO2P07bv__"